import React, { Suspense, lazy } from 'react';
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { GetCookie } from './../Action/GetCookie'
import BottomNavigation from './BottomNavigation';
import Header from './Header';
import './Home.css'
import HomeTabs from './HomeTabs';
import { AllApi } from './../Api/AllApi'
import Snackbar from '@mui/material/Snackbar';

// import Instantstart from './../Public/Image/Home/Instantstart.svg'
// import Bestquality from './../Public/Image/Home/Bestquality.svg'
// import Ongoingsupport from './../Public/Image/Home/Ongoingsupport.svg'
import { useSelector, useDispatch } from 'react-redux'
import Loading from './../Loading'
import UnsuccessfulPayment from '../BottomSheet/UnsuccessfulPayment';
import SuccessfulPayment from '../BottomSheet/SuccessfulPayment';
import { useLocation } from 'react-router-dom';
import { SetEmail } from './../app/Slice'
// import { UpdateCheck } from './../Action/UpdateCheck'
import useCheckUpdate from '../Hooks/useCheckUpdate'; // مسیر را طبق ساختار پروژه تنظیم کن
import { SetCookie } from './../Action/SetCookie'
import { BottomSheet } from 'react-spring-bottom-sheet'
import Coin from './../Public/Image/wheel/coin.png'
// import WheelOfFortune from './WheelOfFortune';

import {
  setBottomSheetsuccessfulPayment,
  setBottomSheetUnsuccessfulPayment,
  setUserFromApi,
  SetPackageData,
  setViewPackageData,
  setLoading,
  setUserCoin,
  setIsIranian,
  SetUpdate,
  SetUpdateVersion,
  SetTab,
} from './../app/Home';
import FooterInfo from './FooterInfo'
const MemberTab = lazy(() => import('./TabsContent/MemberTab'));
const ViewTab = lazy(() => import('./TabsContent/ViewTab'));
const ReactTab = lazy(() => import('./TabsContent/ReactTab'));

const Home = () => {

  const Token = GetCookie('Token')
  const dispatch = useDispatch()

  const LoadingState = useSelector((state) => state.Home.Loading)
  const history = useHistory();
  let AuthState = GetCookie('Token')
  const Tab = useSelector((state) => state.Home.Tab)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const PaymentReturn = searchParams.get('payment');
  const PaymentReturnView = searchParams.get('paymentview');
  const paymentReturnreact = searchParams.get('paymentreact');
  const messageid = searchParams.get('id')

  // const Point = searchParams.get('point');
  // const CountPost = searchParams.get('countPost');

  // const [PaymentErrorState, setPaymentErrorState] = useState(false)
  // const [Data, setData] = useState([])
  const PackageData = useSelector((state) => state.Home.PackageData)
  // const UserFromApi = useSelector((state) => state.Home.UserFromApi)
  const IsIranian = useSelector((state) => state.Home.IsIranian)


  useCheckUpdate();

  const clearAuthCookiesAndRedirect = () => {
    document.cookie = "Token=; Max-Age=-99999999;";
    document.cookie = "active=; Max-Age=-99999999;";
    history.push("/");
  };
  const GetViewFunc = async (status) => {
    // dispatch(setLoading(true));
    try {
      const MakeApiClass = new AllApi();
      let res = await MakeApiClass.GetView(status)

      switch (res.code) {
        case 200:
          dispatch(setViewPackageData(res.data.data));
          break;

        case 120:
        case 121:
        case 122:
        case 123:
          clearAuthCookiesAndRedirect();
          return;

        default:
          // Handle other error codes if needed
          break;
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
      // dispatch(setLoading(false));
    }
  };

  const GetMemberFunc = async (status) => {
    // dispatch(setLoading(true));

    try {
      const api = new AllApi();
      const res = await api.GetMember(status);

      switch (res.code) {
        case 200:
          dispatch(setUserCoin(res.data.user.coins));
          dispatch(SetPackageData(res.data.data));
          break;

        case 120:
        case 121:
        case 122:
        case 123:
          clearAuthCookiesAndRedirect();
          return;

        case 999:
          // Specific handling for code 999 if needed
          break;

        default:
          console.warn("Unhandled response code:", res.code);
          break;
      }
    } catch (error) {
      console.error("Error fetching member data:", error);
    } finally {
      // dispatch(setLoading(false));
    }
  };


  const GetProfile1 = async () => {
    try {
      const api = new AllApi();
      const response = await api.GetProfile(Token);

      if (response.code !== 200) return;

      const user = response.data.user;
      const email = response.data.email;

      dispatch(setUserFromApi(user));
      dispatch(SetEmail(email));

      const phone = user?.phonenumber || "";
      const isIranian = phone.startsWith("+98");

      dispatch(setIsIranian(isIranian));

      // فراخوانی توابع وابسته به ملیت کاربر
      await GetMemberFunc(isIranian);
      await GetViewFunc(isIranian);
      dispatch(setLoading(false));
    } catch (error) {
      console.error("Error in GetProfile:", error);
    }
  };

  useEffect(() => {

    dispatch(SetPackageData([]))
    dispatch(setViewPackageData([]))

    GetProfile1()
  }, [])

  const [CoinReward, setCoinReward] = useState(false)
  const [CoinRewardCount, setCoinRewardCount] = useState('')
  function onDismiss() {
    setTimeout(() => {
      setCoinReward(false)
    }, 300);

  }

  const [Snackopen, setSnackOpen] = useState(false)

  const handleClick = () => {
    setSnackOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackOpen(false);
  };

  const getgiveSpin = async (Gifttoken) => {
    const api = new AllApi();
    // console.log(Gifttoken)
    if (Gifttoken) {
      const res = await api.GiveSpin(Gifttoken)
      // console.log(res)
      if (res.data.code == 200 && !res.data.data.data.claimReward) {
        // console.log(res.data.data)

        localStorage.setItem('GiftUser', JSON.stringify(res.data.data.data))
        let gift = res.data.data.data.gift
        let id = res.data.data.data.Id
        let token = res.data.data.data.token
        if (res.data.data.data.rewardType == 'member') {
          SetCookie('Gifttoken', null, -100);
          history.push(`/GetLinkUsername?Price=0&Count=${gift}&ByCoin=false&_id=${id}&sku=''`);


        } else if (res.data.data.data.rewardType == 'view') {
          SetCookie('Gifttoken', null, -100);
          history.push(`/GetUsernameView?price=0&count=${gift}&PostViewFilter=1&&ByCoin=false&_id=${id}&sku=''`);

          // GetUsernameView?price=0.49&count=200&ByCoin=false&PostViewFilter=1&sku=606&_id=67481b52a5cfb126b2214e55
        } else if (res.data.data.data.rewardType == 'react') {
          SetCookie('Gifttoken', null, -100);
          history.push(`/SelectEmoji?Price=0&Count=${gift}&ByCoin=false&_id=${id}&sku=''`);

          // SelectEmoji?Price=0.99&Count=200&_id=68971467a5cfb126b2214ebb&sku=WebAppP_react_01&ByCoin=false
        } else if (res.data.data.data.rewardType == 'coin') {
          // alert(`coin reward is ${gift}`)
          // token
          const api = new AllApi();
          // let gift = JSON.parse(localStorage.getItem("GiftUser"))
          //  console.log(gift.token,UserNameForOrder)
          const res = await api.SaveSpin(token, Token)
          // console.log(res)
          if (res.code === 301) {
            setSnackOpen(true)

          } else if (res.code == 200 && res.data != null) {
            dispatch(setUserCoin(res.data.user.coins));

            setCoinRewardCount(gift)
            setCoinReward(true)
            SetCookie('Gifttoken', null, -100);
            localStorage.removeItem('GiftUser', null)
          } else {
            SetCookie('Gifttoken', null, -100);
            setSnackOpen(true)
            localStorage.removeItem('GiftUser', null)

          }

        }
        // console.log(res.data.data.data)
      } else {
        SetCookie('Gifttoken', null, -100);
        localStorage.removeItem('GiftUser')

        setSnackOpen(true)

      }
    }

  }




  useEffect(() => {




    if (!AuthState) {
      history.push('/');
      return;
    } else {
      let Gifttoken = GetCookie('Gifttoken');
      getgiveSpin(Gifttoken)


      // console.log(Gifttoken)
      // console.log(Token)
    }

    const handlePayment = (param, tabName = null) => {
      const value = searchParams.get(param);

      if (value === 'true') {
        dispatch(setBottomSheetsuccessfulPayment(true));
        if (tabName) {
          searchParams.set('Status', tabName);
          dispatch(SetTab(tabName));
        }
      } else if (value === 'false') {
        dispatch(setBottomSheetUnsuccessfulPayment(true));
        if (tabName) {
          searchParams.set('Status', tabName);
          dispatch(SetTab(tabName));
        }
      } else {
        return; // Skip if param not present
      }

      // Clean up common params
      ['count', 'countPost', 'username', 'point', 'id', 'emoji', param].forEach((p) => searchParams.delete(p));

      const newUrl = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({ path: newUrl }, '', newUrl);
    };

    handlePayment('payment');            // Member
    handlePayment('paymentview', 'View');
    handlePayment('paymentreact', 'React');

  }, [AuthState]);



  return (
   <>
   
   {
      LoadingState ? <Loading />:  <div className='Home'>
      <div className='Header'>
        <Header />
      </div>
      <div className='Content'>
        <HomeTabs />

        <Suspense fallback={<Loading />}>
          {Tab === 'Member' && <MemberTab PackageData={PackageData} IsIranian={IsIranian} />}
          {Tab === 'View' && <ViewTab IsIranian={IsIranian} />}
          {Tab === 'React' && <ReactTab PackageData={PackageData} IsIranian={IsIranian} />}
        </Suspense>

        {/* <WheelOfFortune /> */}

      </div>
      <FooterInfo />

      <div className='NavContainer'>
        <BottomNavigation />
      </div>
      <UnsuccessfulPayment />
      <SuccessfulPayment />
      <BottomSheet onDismiss={onDismiss} open={CoinReward}>
        <div className='RegisterBeforeBottomSheet'>
          <div className='RegisterBeforeBottomSheetHeader'>
            <div className={`RegisterBeforeBottomSheetHeaderText `}>
              <div >
                🎉 Reward Claimed  🎉
              </div>
            </div>
          </div>
          <div className='RegisterBeforeBottomSheetBody' style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            {CoinRewardCount} <img width={18} height={18} src={Coin} style={{ margin: "0 4px 0 4px" }} />     have been added to your account
          </div>
          <div className='RegisterBeforeBottomSheetFooter'>
            {/* <button className='BottomSheetCancelButton' onClick={() => setCoinReward(false)}>got it</button> */}
            <button className='BottomSheetLoginButton' style={{ width: "100%" }} onClick={() => setCoinReward(false)}>Got it</button>
          </div>
        </div>
      </BottomSheet>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={Snackopen}
        autoHideDuration={4000}
        onClose={handleClose}
        message=" Something went wrong!"
      // action={action}
      />
    </div>
    }
     </>
  
  )
}

export default Home